export default "__VITE_ASSET__BwQRC3mC__"